import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteOccupationInformation: Map<string, ConfirmationData> = new Map([
    ["31bd549b-e54f-4413-be38-840b7b833346", { hidden: true }],
]);



